module.exports = __webpack_public_path__ + "media/images/csv-download-71b54978cabaedec43df32f2a4a2da6c.svg";